import TrackingEvent, { TrackingProperty } from 'constants/trackingEvents';
import { useTranslation } from 'react-i18next';
import { routes } from 'utils/routerHelpers';
import { isAdmin } from 'utils/userHelpers';

import React from 'react';

import { ActionMenu } from '@thinkific/chalk/ActionMenu';
import { Button } from '@thinkific/chalk/Button';
import { SquaresFour } from '@thinkific/chalk/react-icons';

import { useCommunityContext } from 'components/CommunityContext';

import * as css from './SiteNav.css';

const AllPowerfulSiteLogo = () => {
  const { t } = useTranslation();
  const { trackEvent, site } = useCommunityContext();
  return (
    <ActionMenu
      items={[
        {
          label: t('components-topBar-all_button', 'All communities'),
          onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            trackEvent(TrackingEvent.GO_TO_CUSTOMIZE_COMMUNITY, {
              [TrackingProperty.COMPONENT]: 'GlobalHeader',
            });
            window.open(routes.communities, '_blank');
          },
          href: routes.communities,
          target: '_blank',
        },
        {
          label: t('components-topBar-view-dashboard_button', 'View student dashboard'),
          onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            trackEvent(TrackingEvent.GO_TO_DASHBOARD, {
              [TrackingProperty.COMPONENT]: 'GlobalHeader',
            });
            window.open(routes.dashboard, '_blank');
          },
          href: routes.dashboard,
          target: '_blank',
        },
        {
          label: t('components-topBar-admin_button', 'Go to admin dashboard'),
          onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            trackEvent(TrackingEvent.GO_TO_ADMIN, {
              [TrackingProperty.COMPONENT]: 'GlobalHeader',
            });
            window.open(routes.admin, '_blank');
          },
          href: routes.admin,
          target: '_blank',
        },
      ]}
    >
      <Button
        aria-label={
          t('components-topBar-admin_dropdown-arialabel', 'Open menu for admin settings') as string
        }
        className={css.dashboardButton}
        data-user-pilot-id="site-nav-logo"
        emphasis="low"
        icon={SquaresFour}
        size="sm"
        hiddenLabel
      >
        {site.name}
      </Button>
    </ActionMenu>
  );
};

export const SiteLogo = () => {
  const { currentUser } = useCommunityContext();
  const { t } = useTranslation();
  if (isAdmin(currentUser)) return <AllPowerfulSiteLogo />;

  return (
    <Button
      className={css.dashboardButton}
      emphasis="low"
      icon={SquaresFour}
      size="sm"
      hiddenLabel
      onClick={() => {
        window.location.href = routes.dashboard;
      }}
    >
      {t('components-topBar-student_dashboard_button', 'My Dashboard')}
    </Button>
  );
};

export default SiteLogo;
